import { render } from "./ClienteConsulta.vue?vue&type=template&id=641671b5&scoped=true"
import script from "./ClienteConsulta.vue?vue&type=script&lang=js"
export * from "./ClienteConsulta.vue?vue&type=script&lang=js"

import "./ClienteConsulta.vue?vue&type=style&index=0&id=641671b5&scoped=true&lang=css"

import exportComponent from "C:\\Users\\guilherme.goncalves\\Documents\\FDVSolution\\FDVSolution\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-641671b5"]])

export default __exports__